import { useMemo } from 'react';
import { useCurrencyMappingListQuery } from 'queries/account';
export const useAccountCurrency = ()=>{
    const { data: currencyMappingList } = useCurrencyMappingListQuery();
    const currencyCache = useMemo(()=>{
        if (currencyMappingList == null || currencyMappingList.length === 0) {
            return undefined;
        }
        const temp = {};
        currencyMappingList.forEach((currencyMapping)=>{
            if (currencyMapping.defaultCurrency) {
                temp.default = currencyMapping.currency;
            }
            if (currencyMapping.enabled) {
                temp.enabled = {
                    ...temp.enabled,
                    [currencyMapping.currency.currencyCode]: currencyMapping
                };
            }
            temp.all = {
                ...temp.all,
                [currencyMapping.currency.currencyCode]: currencyMapping
            };
        });
        return temp;
    }, [
        currencyMappingList
    ]);
    return currencyCache;
};
